import React, { useState, useEffect } from "react";
import { FaHeart, FaPlusCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { FaStar } from "react-icons/fa";
import "../../assets/css/temoignage.css";
import Modal from "react-modal";

Modal.setAppElement("#root");

function TestimonialItem({ testimonial, onLike }) {
    // La prop onLike est maintenant passée
    const { t } = useTranslation("temoignage");
    const [likes, setLikes] = useState(testimonial.likes || 0);
const API_BASE_URL = process.env.REACT_APP_API_URL;
    useEffect(() => {
        const fetchLikes = async () => {
            try {
                const response = await fetch(
                    `${API_BASE_URL}/api/testimonials/${testimonial.id}/likes`
                );
                if (!response.ok) {
                    console.error(`Erreur HTTP ! statut: ${response.status}`);
                    return;
                }
                const data = await response.json();
                setLikes(data.likes);
            } catch (error) {
                console.error(
                    "Erreur lors de la récupération des likes:",
                    error
                );
            }
        };

        fetchLikes();
    }, [testimonial.id]);

    const handleLikeClick = async () => {
        try {
            const response = await fetch(
                `${API_BASE_URL}/api/testimonials/${testimonial.id}/like`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            if (response.ok) {
                const data = await response.json();
                setLikes(data.likes);
                if (onLike) {
                    onLike(testimonial.id, data.likes); // Passez l'ID et le nouveau nombre de likes
                }
            } else {
                console.error(`Erreur HTTP ! statut: ${response.status}`);
            }
        } catch (error) {
            console.error("Erreur lors du like:", error);
        }
    };

    return (
        <div className="testimonial-item">
            <p className="testimonial-text">"{testimonial.texte}"</p>
            <div className="testimonial-info">
                <span className="testimonial-name">
                    - {testimonial.nom_auteur}
                </span>
                <div className="testimonial-actions">
                    <button className="like-button " onClick={handleLikeClick}>
                        <FaHeart className="likebt" />
                        <span className="likebt"> {likes}</span>
                    </button>
                </div>
            </div>
        </div>
    );
}
function AddTestimonialForm({ onAdd, onClose }) {
    const { t } = useTranslation("temoignage");
    const [name, setName] = useState("");
    const [text, setText] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async () => {
        if (!name.trim() || !text.trim()) {
            setError(t("formulaire.erreurChamps"));
            return;
        }

        try {
            await onAdd({ nom_auteur: name, texte: text });
            onClose();
        } catch (err) {
            setError(t("formulaire.erreurEnvoi"));
            console.error("Erreur lors de l'envoi du témoignage:", err);
        }
    };

    return (
        <div className="add-testimonial-form">
            <h3>{t("formulaire.titre")}</h3>
            {error && <p className="error-message">{error}</p>}
            <div className="form-group">
                <p className="itemForm">{t("formulaire.nom")}:</p>
                <input
                    type="text"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />
            </div>
            <div className="form-group">
                <p className="itemForm">{t("formulaire.temoignage")}:</p>
                <textarea
                    id="text"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    required
                />
            </div>
            <div className="form-actions">
                <button
                    onClick={handleSubmit}
                    className="add-testimonial-button"
                >
                    {t("formulaire.ajouter")}
                </button>
                <button onClick={onClose} className="add-testimonial-button">
                    {t("formulaire.annuler")}
                </button>
            </div>
        </div>
    );
}

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: "80%",
        maxWidth: "600px",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
    },
    overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 1000,
    },
};

export default function Temoignage() {
    const { t } = useTranslation("temoignage");
    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isAddingTestimonial, setIsAddingTestimonial] = useState(false);
    const [showAllTestimonialsModal, setShowAllTestimonialsModal] =
        useState(false);
    const latestTestimonials = testimonials.slice(-8).reverse();
const API_BASE_URL = process.env.REACT_APP_API_URL;
    useEffect(() => {
        const fetchTestimonials = async () => {
            try {
                const response = await fetch(
                    `${API_BASE_URL}/api/testimonials`
                );
                if (!response.ok) {
                    throw new Error(`Erreur HTTP ! statut: ${response.status}`);
                }
                const data = await response.json();
                setTestimonials(data);
                setLoading(false);
            } catch (err) {
                setError(t("erreurChargement"));
                console.error(
                    "Erreur lors du chargement des témoignages:",
                    err
                );
                setLoading(false);
            }
        };

        fetchTestimonials();
    }, [t]);

    const handleLikeBackendUpdate = async (testimonialId, newLikes) => {
        // Mettre à jour le nombre de likes dans la liste locale des témoignages
        setTestimonials(
            testimonials.map((t) =>
                t.id === testimonialId ? { ...t, likes: newLikes } : t
            )
        );
    };

    const handleAddTestimonialClick = () => {
        setIsAddingTestimonial(true);
    };

    const handleAddTestimonial = async (newTestimonial) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/testimonials`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(newTestimonial),
            });
            if (!response.ok) {
                throw new Error(`Erreur HTTP ! statut: ${response.status}`);
            }
            const data = await response.json();
            setTestimonials([...testimonials, data]);
        } catch (err) {
            setError(t("erreurEnvoi"));
            console.error("Erreur lors de l'ajout du témoignage:", err);
            throw err;
        }
    };

    const handleCloseAddForm = () => {
        setIsAddingTestimonial(false);
    };

    const handleShowAllTestimonials = () => {
        setShowAllTestimonialsModal(true);
    };

    const handleCloseAllTestimonialsModal = () => {
        setShowAllTestimonialsModal(false);
    };

    if (loading) {
        return <p>{t("loading")}</p>;
    }

    if (error) {
        return <p>{t("error", { error: error })}</p>;
    }

    return (
        <section id="Temoignage" className="testimonials-section">
            <div>
                <FaStar className="testiconne" />
                <FaStar className="testiconne" />
                <FaStar className="testiconne" />
            </div>
            <h2 className="titredd">{t("titre")}</h2>
            <div className="testimonials-list">
                {latestTestimonials.map((testimonial) => (
                    <TestimonialItem
                        key={testimonial.id}
                        testimonial={testimonial}
                        onLike={handleLikeBackendUpdate} // Passez la fonction de mise à jour
                    />
                ))}
            </div>
            {testimonials.length > 8 && (
                <button
                    className="show-more-button"
                    onClick={handleShowAllTestimonials}
                >
                    {t("showMore")}
                </button>
            )}

            <Modal
                isOpen={showAllTestimonialsModal}
                onRequestClose={handleCloseAllTestimonialsModal}
                style={customStyles}
                contentLabel={t("tousLesTemoignages")}
            >
                <h2>{t("tousLesTemoignages")}</h2>
                <div className="all-testimonials-modal-content">
                    {testimonials.map((testimonial) => (
                        <TestimonialItem
                            key={testimonial.id}
                            testimonial={testimonial}
                            onLike={handleLikeBackendUpdate} // Passez également la fonction au modal
                        />
                    ))}
                </div>
                <button
                    onClick={handleCloseAllTestimonialsModal}
                    className="close-modal-button"
                >
                    {t("fermer")}
                </button>
            </Modal>

            {isAddingTestimonial && (
                <AddTestimonialForm
                    onAdd={handleAddTestimonial}
                    onClose={handleCloseAddForm}
                />
            )}
            {!isAddingTestimonial && (
                <button
                    className="add-testimonial-button"
                    onClick={handleAddTestimonialClick}
                >
                    <FaPlusCircle /> {t("addYourTestimonial")}
                </button>
            )}
        </section>
    );
}
